module.exports = __webpack_public_path__ + "img/box-family.dbb83729.jpg";